export default "__VITE_ASSET__D$rZyT4X__"